import Footer from "@/components/footer/Footer";
import type { IconName } from "@/components/icon/IconName";
import Navbar from "@/components/navbar/Navbar";
import { DESKTOP } from "@/constant/breakpoints";
import { ADMIN, ART, JEWELRY, LOGIN, LOGS, RESET_PASSWORD, USERS } from "@/constant/routes";
import { AuthContext, type AuthContextProps } from "@/contexts/auth/Auth";
import { LoadingScreen } from "@/features/loading-screen";
import { useSupabaseClient } from "@/hooks/useSupabaseClient";
import { useWindowSize } from "@/hooks/useWindowSize";
import React, { Suspense, useContext, useEffect, useState } from "react";


import { Navigate, useNavigate } from "react-router-dom";

interface PrivateRouteProps {
  children: React.ReactNode;
}
const supabase = useSupabaseClient();

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const { user, loading, signOut } = useContext(AuthContext) as AuthContextProps;
    const [currentRole, setCurrentRole] = useState("");
    const isDesktop = useWindowSize().width > DESKTOP;
   
    const [ displayName, setDisplayName ] = useState("");
    const navigate = useNavigate();

    const getDisplayName = async () => {
            const { data, error } = await supabase.rpc("get_full_name")
            if (error) {
                console.error(error);
                return;
        
            }
            setDisplayName(data)
    };

    const getRole = async () => {
      const { data } = await supabase.rpc("get_my_role")
      setCurrentRole(data);
    }

    useEffect(() => {
      getRole();
      getDisplayName();

    },[]);

    const selectItems = [
      {
        label: "Réinitialisation mot de passe",
        iconName: "password" as IconName,
        onClick: () => navigate(RESET_PASSWORD)
      },
      {
        label: "Se déconnecter",
        iconName: "logout" as IconName,
        onClick: () => signOut()
      },
    ];

    const navbarItems = [
      { label: "Art", iconName: "art" as IconName, link: ART },
      { label: "Jewelry", iconName: "jewelry" as IconName, link: JEWELRY },
      ...(currentRole === "admin" && !isDesktop 
        ? [{label: "Utilisateurs", iconName: "user" as IconName, link: USERS},
          {label: "Logs", iconName: "document" as IconName, link: LOGS}]
        : []),
    ];
    
    if (loading) {
      return <LoadingScreen />;
    }

    if (!user) {
      return <Navigate to={LOGIN} replace />;
    }

  return (
  <Suspense>
      <Navbar displayName={displayName} onClick={signOut} options={selectItems} navbarItems={navbarItems}/>
      {children}
      <Footer/>
  </Suspense>
  );
};
